if (!customElements.get('card-media-carousel')) {
  customElements.define(
    'card-media-carousel',
    class CardMediaCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.card-media-carousel__track');
        this.slides = Array.from(this.querySelectorAll('.card-media-carousel__slide'));
        this.dotsEl = this.querySelector('.card-media-carousel__dots');
        this.dots = this.dotsEl
          ? Array.from(this.dotsEl.querySelectorAll('.card-media-carousel__dot'))
          : [];
        this.prevBtn = this.querySelector('.card-media-carousel__arrow--prev');
        this.nextBtn = this.querySelector('.card-media-carousel__arrow--next');
        this.current = 0;
        this.maxDots = 3; // never show more than this many dots at once
        this._scrollTimer = null;

        if (!this.track || this.slides.length < 2) return;

        // Move the dots OUT of the overflow-clipped media box so they render in the
        // card's flow directly UNDER the photo (between the image and the title) on
        // both desktop and mobile. The dot nodes keep their references and click
        // listeners, so relocating the container changes nothing about behaviour.
        const cardInner = this.closest('.card__inner');
        if (this.dotsEl && cardInner && typeof cardInner.after === 'function') {
          cardInner.after(this.dotsEl);
        }

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.go(this.current - 1);
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.go(this.current + 1);
          });
        }
        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.go(i);
          });
        });

        this.track.addEventListener(
          'scroll',
          () => {
            if (this._scrollTimer) clearTimeout(this._scrollTimer);
            this._scrollTimer = setTimeout(() => this.syncFromScroll(), 60);
          },
          { passive: true }
        );

        this.update();
      }

      go(index) {
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        const slide = this.slides[target];
        if (!slide) return;
        this.current = target;
        this.update();
        this.scrollToPos(slide.offsetLeft);
      }

      scrollToPos(end) {
        const start = this.track.scrollLeft;
        if (Math.abs(end - start) < 1) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try {
          this.track.scrollTo({ left: end, behavior: reduce ? 'auto' : 'smooth' });
        } catch (e) {
          this.track.scrollLeft = end;
        }
        // Fallback: if the engine ignored programmatic smooth scrolling, snap instantly.
        setTimeout(() => {
          if (Math.abs(this.track.scrollLeft - end) > 2) this.track.scrollLeft = end;
        }, 400);
      }

      syncFromScroll() {
        const width = this.track.clientWidth;
        if (!width) return;
        const index = Math.round(this.track.scrollLeft / width);
        if (index !== this.current) {
          this.current = index;
          this.update();
        }
      }

      update() {
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.current));
        this.applyDotWindow();
        if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', this.current <= 0);
        if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', this.current >= this.slides.length - 1);
      }

      // Show at most `maxDots` dots. With more images, a sliding window follows the
      // active image; overflow dots are simply hidden (all visible dots are equal size).
      applyDotWindow() {
        const n = this.dots.length;
        const max = this.maxDots;
        this.dots.forEach((d) => {
          d.classList.remove('is-hidden', 'is-edge');
        });
        if (n <= max) return;
        let start = Math.min(Math.max(this.current - 1, 0), n - max);
        const end = start + max - 1;
        this.dots.forEach((d, i) => {
          if (i < start || i > end) {
            d.classList.add('is-hidden');
            return;
          }
          if ((i === start && start > 0) || (i === end && end < n - 1)) {
            d.classList.add('is-edge');
          }
        });
      }
    }
  );
}
